import type { Recommendation } from "./recommendation";

export interface ABTestAPIResponse {
  startDate: string;
  endDate: string;
  reportingDimension: string;
  groups: ABTestGroup[];
}

export interface ABTestGroup {
  group: string;
  reportingValue: string;
  recommendationItems: Recommendation[];
}

export interface ABTestDb {
  [scenario: string]: ABTestScenario;
}

export interface ABTestScenario {
  startDate: string;
  endDate: string;
  group: string;
  reportingDimension?: string;
  reportingValue?: string;
  recommendationItems?: Recommendation[];
}

export type Nullable<T> = T | null;

export type Undefinedable<T> = T | undefined;

export enum ABTestT82 {
  DEFAULT = "default",
  A1_CROSSSELLING = "a1_crossselling",
}
